import * as types from '../actions';

const initialState = {
    docItems:[],
    items: [],
    item:{
        docId:'',
        document:'',
        startDate:'',
        endDate:'',
        docType:'',
        dateRangeRequired:false
    },
    errorData:'',
    activity:'',
    status:'',
};

export default function(state = initialState, action) {
    const response = action.response;

    switch(action.type) {

        case types.DOCUMENT_SKILL_LIST_SUCCESS:
            return {
                ...state,
                docItems:response.data,
                status: response.status,  
                activity:types.DOCUMENT_SKILL_LIST_SUCCESS,                               
            };

        case types.DOCUMENT_LIST_SUCCESS:
            return {
                ...state,
                items:response.data,
                status: response.status,  
                activity:types.DOCUMENT_LIST_SUCCESS,                               
            };
        
        case types.DOCUMENT_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,               
                    status: response.status,  
                    activity:types.DOCUMENT_ADD_SUCCESS,                               
                };
            }else{
                return {
                    ...state,               
                    status: response.status,  
                    activity:types.DOCUMENT_ADD_ERROR, 
                    errorData:response.data                              
                };
            }            

        case types.DOCUMENT_EDIT_SUCCESS:
            return {
                ...state,
                item:{
                    docId:response.data.id,
                    document:response.data.crew_skill_details===null?'doc_'+response.data.affiliate_document_details.id:'skill_'+response.data.crew_skill_details.id,
                    startDate:response.data.valid_from,
                    endDate:response.data.valid_to,
                    docType:response.data.crew_skill_details===null?"2":"3",
                    dateRangeRequired:response.data.affiliate_document_details!==null?response.data.affiliate_document_details.date_range:response.data.crew_skill_details.affiliate_skill.date_range?true:false

                },
                status: response.status,  
                activity:types.DOCUMENT_EDIT_SUCCESS,                               
            };
        
        case types.DOCUMENT_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,               
                    status: response.status,  
                    activity:types.DOCUMENT_UPDATE_SUCCESS,                               
                };
            }else{
                return {
                    ...state,               
                    status: response.status,  
                    activity:types.DOCUMENT_UPDATE_ERROR, 
                    errorData:response.data                              
                };
            }

            case types.DOCUMENT_DELETE_SUCCESS:
                const id = response.data.id;
                if(response.status===200){
                    return {
                        ...state,    
                        items: state.items.filter(items => items.docId !== id),            
                        status: response.status,  
                        activity:types.DOCUMENT_DELETE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_DELETE_ERROR, 
                        errorData:response.data                              
                    };
                }
            case types.DOCUMENT_FILE_SAVE_SUCCESS:
                if(response.status===201){
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_FILE_SAVE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_FILE_SAVE_ERROR, 
                        errorData:response.data                              
                    };
                }

            case types.DOCUMENT_FILE_DELETE_SUCCESS:
                if(response.status===200){
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_FILE_DELETE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_FILE_DELETE_ERROR, 
                        errorData:response.data                              
                    };
                }
            case types.DOCUMENT_STATUS_UPDATE_SUCCESS:
                if(response.status===200){
                    return {
                        ...state,    
                        docStatus:response.data,         
                        status: response.status,  
                        activity:types.DOCUMENT_STATUS_UPDATE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.DOCUMENT_STATUS_UPDATE_ERROR, 
                        errorData:response.data                              
                    };
                }

            case types.PASSPORT_FILE_SAVE_SUCCESS:
                if(response.status===201){
                    return {
                        ...state,               
                        status: response.status,  
                        passport_url: response.data.passport_url,
                        activity:types.PASSPORT_FILE_SAVE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.PASSPORT_FILE_SAVE_ERROR, 
                        errorData:response.data                              
                    };
                }
            
            case types.VISA_FILE_SAVE_SUCCESS:
                if(response.status===201){
                    return {
                        ...state,               
                        status: response.status,  
                        visa_url: response.data.visa_url,
                        activity:types.VISA_FILE_SAVE_SUCCESS,                               
                    };
                }else{
                    return {
                        ...state,               
                        status: response.status,  
                        activity:types.VISA_FILE_SAVE_ERROR, 
                        errorData:response.data                              
                    };
                }

        case types.CLEAR:
        return {
            ...state,
            status:0,
            activity:types.CLEAR,
        } 
       
        default:
            return state;

    }
}